import React, {Component} from 'react'
import {connect} from 'react-redux'
import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableFooter from '@material-ui/core/TableFooter'
import Paper from '@material-ui/core/Paper'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import _ from 'lodash'
import {reduxForm, formValueSelector} from 'redux-form'
import Slide from '@material-ui/core/Slide'
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import CopyToClipboard from 'react-copy-to-clipboard';
import Pagination from '../../../../../uis/pagination'
import NoData from '../../../../../uis/noData'
import * as actions from '../reducers/list'
import Text from '../../../../../uis/form/text';
import Select from '../../../../../uis/form/select'
import dateFormat from '../../../../../util/dateFormat'
import * as tip from '../../../../../uis/tip/reduces'


const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    appBar: {
        position: 'relative',
    },
    flex: {
        flex: 1,
    },
    table: {
        minWidth: 700,
    },
    dialog: {
        maxWidth: 900
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    textField: {
        width: 300,
        margin: theme.spacing.unit * 2
    },
    doubleTextField: {
        width: (300 * 2) + (theme.spacing.unit * 4),
        margin: theme.spacing.unit * 2
    },
    dislogActions: {
        display: 'flex',
        justifyContent: 'space-around',
        margin: theme.spacing.unit * 3
    },
    contentCell: {
        maxWidth: 100,
        whiteSpace: 'noWrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
    },
    tableCell: {
        padding: '4px 28px 4px 12px'
    },
    more: {
        display: 'inline-block',
        maxWidth: 100,
        whiteSpace: 'noWrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
    },
    group: {
        margin: `${theme.spacing.unit}px 0`,
        flexDirection: 'row'
    },
    showMe: {
        marginLeft: theme.spacing.unit * 2
    },
    baojiadanTable: {
        width: 800,
        margin: '20px auto'
    },
    baojiadanFooter: {
        color: '#6c757d'
    }
})

const validate = values => {
    const errors = {}
    
    if (!values.aliwangwang) {
        errors.aliwangwang = '必填'
    }
    if (!values.link) {
        errors.link = '必填'
    }
    return errors
}

const priceObj = {
    menuCount: {
        "1": 200,
        "1-5": 300,
        "5-10": 400,
        "10-20": 500,
        "20-30": 600
    },
    hasForm: 100,
    hasNews: 150,
    hasProduct: 150,
    hasFocus: 50,
    hasMap: 50,
    hasImages: 100,
    hasVideos: 100,
    hasFiles: 100,
    hasDomain: 50,
    hasSpace: 100,
    hasCdn: 100,
    hasBeiancode: 50
}

function Transition(props) {
    return <Slide {...props} direction="up" />
}

function getBaojia(detail) {
    return priceObj.menuCount[detail.menuCount] 
            + (detail.hasMobile ? (priceObj.menuCount[detail.menuCount] / 2) : 0)
            + (detail.hasForm ? priceObj.hasForm : 0)
            + (detail.hasNews ? priceObj.hasNews : 0)
            + (detail.hasProduct ? priceObj.hasProduct : 0)
            + (detail.hasFocus ? priceObj.hasFocus : 0)
            + (detail.hasMap ? priceObj.hasMap : 0)
            + (detail.hasImages ? priceObj.hasImages : 0) 
            + (detail.hasVideos ? priceObj.hasVideos : 0) 
            + (detail.hasFiles ? priceObj.hasFiles : 0)
            + (detail.hasDomain ? priceObj.hasDomain : 0)
            + (detail.hasSpace ? priceObj.hasSpace : 0)
            + (detail.hasBeiancode ? priceObj.hasBeiancode : 0)
            + (detail.hasCdn ? priceObj.hasCdn : 0)
}
class AddDialog extends React.Component {
    render() {
        const {classes, dispatch, showModal, pristine, submitting, handleSubmit} = this.props
        return (<Dialog
            open={showModal.add}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullScreen
            TransitionComponent={Transition}
        >
            <form onSubmit={(handleSubmit)} noValidate autoComplete="off">
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton color="inherit" onClick={() => dispatch({type: actions.HIDE_MODAL})}>
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="title" color="inherit" className={classes.flex}>
                            新增报价单
                        </Typography>
                        <Button color="inherit" type="submit" disabled={pristine || submitting}>
                            确定
                        </Button>
                    </Toolbar>
                </AppBar>
                <DialogContent className={classes.dialogContent}>
                    <div>
                        <Select name="category" label="仿站类型" placeholder="请输入仿站类型" className={classes.textField} required={true} data={[{"name":"单页","value":"单页"},{"name":"单页带表单","value":"单页带表单"},{"name":"公司官网H5","value":"公司官网H5"},{"name": "公司官网3合1", "value": "公司官网3合1"}, {"name":"营销推广","value":"营销推广"}]}/>
                        <Text name="link" label="仿站链接" placeholder="请输入仿站链接" className={classes.textField} required={true}/>
                    </div>
                    <div>
                        <Text name="aliwangwang" label="客户旺旺号" placeholder="请输入客户旺旺号" className={classes.textField} required={true}/>
                        <Select name="menuCount" label="栏目数量" placeholder="请选择栏目数量" className={classes.textField} required={true} data={[{"name":"1个","value":"1"},{"name":"1到5个","value":"1-5"},{"name":"5到10个","value":"5-10"},{"name":"10到20个","value":"10-20"},{"name":"20到30个","value":"20-30"}]}/>
                    </div>
                    <div>
                        <Select name="hasMobile" label="是否有独立手机端" placeholder="请选择独立手机端" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                        <Select name="languageCount" label="语言数量" placeholder="请选择语言数量" className={classes.textField} required={true} data={[{"name":"1种","value":1},{"name":"2种","value":2},{"name":"3种","value":3}]}/>
                    </div>
                    <div>
                        <Select name="hasForm" label="是否有表单模块" placeholder="请选择表单模块" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                        <Select name="hasNews" label="是否有新闻模块" placeholder="请选择新闻模块" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                    </div>
                    <div>
                        <Select name="hasProduct" label="是否有产品模块" placeholder="请选择产品模块" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                        <Select name="hasFocus" label="是否有焦点图" placeholder="请选择焦点图" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                    </div>
                    <div>
                        <Select name="hasMap" label="是否有地图模块" placeholder="请选择地图模块" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                        <Select name="hasImages" label="是否有图片集模块" placeholder="请选择图片集模块" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                    </div>
                    <div>
                        <Select name="hasVideos" label="是否有视频播放模块" placeholder="请选择视频播放模块" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                        <Select name="hasFiles" label="是否有文档下载模块" placeholder="请选择文档下载模块" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                    </div>
                    <div>
                        <Select name="hasDomain" label="是否需要域名" placeholder="请选择是否需要域名" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                        <Select name="hasSpace" label="是否需要云空间" placeholder="请选择是否需要云空间" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                    </div>
                    <div>
                        <Select name="hasBeiancode" label="是否需要备案码" placeholder="请选择是否需要备案码" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                        <Select name="hasCdn" label="是否需要CDN" placeholder="请选择是否需要CDN" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                    </div>
                </DialogContent>
            </form>
        </Dialog>)
    }
}
class UpdateDialog extends Component {
    render() {
        const {classes, dispatch, showModal, pristine, submitting, handleSubmit} = this.props
        return (<Dialog
            open={showModal.update}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullScreen
            TransitionComponent={Transition}
        >
            <form onSubmit={(handleSubmit)} noValidate autoComplete="off">
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton color="inherit" onClick={() => dispatch({type: actions.HIDE_MODAL})}>
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="title" color="inherit" className={classes.flex}>
                        {showModal.disabled ? '查看' : '修改'}报价单
                        </Typography>
                        {!showModal.disabled && <Button color="inherit" type="submit" disabled={pristine || submitting}>
                            确定
                        </Button>}
                    </Toolbar>
                </AppBar>
                <DialogContent className={classes.dialogContent}>
                <div className={classes.doubleTextField}>
                        <Text name="link" label="仿站链接" placeholder="请输入仿站链接" className={classes.textField} style={{width: "100%", marginLeft: 0, marginRight: 0}} required={true}/>
                    </div>
                    <div>
                        <Text name="aliwangwang" label="客户旺旺号" placeholder="请输入客户旺旺号" className={classes.textField} required={true}/>
                        <Select name="menuCount" label="栏目数量" placeholder="请选择栏目数量" className={classes.textField} required={true} data={[{"name":"1个","value":"1"},{"name":"1到5个","value":"1-5"},{"name":"5到10个","value":"5-10"},{"name":"10到20个","value":"10-20"},{"name":"20到30个","value":"20-30"}]}/>
                    </div>
                    <div>
                        <Select name="hasMobile" label="是否有独立手机端" placeholder="请选择独立手机端" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                        <Select name="languageCount" label="语言数量" placeholder="请选择语言数量" className={classes.textField} required={true} data={[{"name":"1种","value":1},{"name":"2种","value":2},{"name":"3种","value":3}]}/>
                    </div>
                    <div>
                        <Select name="hasForm" label="是否有表单模块" placeholder="请选择表单模块" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                        <Select name="hasNews" label="是否有新闻模块" placeholder="请选择新闻模块" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                    </div>
                    <div>
                        <Select name="hasProduct" label="是否有产品模块" placeholder="请选择产品模块" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                        <Select name="hasFocus" label="是否有焦点图" placeholder="请选择焦点图" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                    </div>
                    <div>
                        <Select name="hasMap" label="是否有地图模块" placeholder="请选择地图模块" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                        <Select name="hasImages" label="是否有图片集模块" placeholder="请选择图片集模块" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                    </div>
                    <div>
                        <Select name="hasVideos" label="是否有视频播放模块" placeholder="请选择视频播放模块" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                        <Select name="hasFiles" label="是否有文档下载模块" placeholder="请选择文档下载模块" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                    </div>
                    <div>
                        <Select name="hasDomain" label="是否需要域名" placeholder="请选择是否需要域名" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                        <Select name="hasSpace" label="是否需要云空间" placeholder="请选择是否需要云空间" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                    </div>
                    <div>
                        <Select name="hasBeiancode" label="是否需要备案码" placeholder="请选择是否需要备案码" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                        <Select name="hasCdn" label="是否需要CDN" placeholder="请选择是否需要CDN" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                    </div>
                </DialogContent>
            </form>
        </Dialog>)
    }
}


class BaojiadanDialog extends Component {
    render() {
        const {classes, dispatch, showModal, detail} = this.props
        const totalPrice = getBaojia(detail);
        return (<Dialog
            open={showModal.baojiadan}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullScreen
            TransitionComponent={Transition}
        >
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton color="inherit" onClick={() => dispatch({type: actions.HIDE_MODAL})}>
                        <CloseIcon />
                    </IconButton>
                    <Typography variant="title" color="inherit" className={classes.flex}>
                        生成报价单
                    </Typography>
                </Toolbar>
            </AppBar>
            <DialogContent className={classes.dialogContent}>
                <Table className={classes.baojiadanTable}>
                    <TableHead>
                    <TableRow>
                        <TableCell>服务内容</TableCell>
                        <TableCell>预估价格</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>
                                网页数量: {detail.menuCount}, 语言数量: {detail.languageCount}
                            </TableCell>
                            <TableCell>
                                {priceObj.menuCount[detail.menuCount]}
                            </TableCell>
                        </TableRow>
                        {detail.hasMobile && <TableRow>
                            <TableCell>
                                独立手机端
                            </TableCell>
                            <TableCell>
                                {(priceObj.menuCount[detail.menuCount] / 2)}
                            </TableCell>
                        </TableRow>}
                        {detail.hasForm && <TableRow>
                            <TableCell>
                                表单数据收集功能
                            </TableCell>
                            <TableCell>
                                {priceObj.hasForm}
                            </TableCell>
                        </TableRow>}
                        {detail.hasNews && <TableRow>
                            <TableCell>
                                动态新闻栏目功能
                            </TableCell>
                            <TableCell>
                                {priceObj.hasNews}
                            </TableCell>
                        </TableRow>}
                        {detail.hasProduct && <TableRow>
                            <TableCell>
                                动态产品栏目功能
                            </TableCell>
                            <TableCell>
                                {priceObj.hasProduct}
                            </TableCell>
                        </TableRow>}
                        {detail.hasFocus && <TableRow>
                            <TableCell>
                                动态焦点图功能
                            </TableCell>
                            <TableCell>
                                {priceObj.hasFocus}
                            </TableCell>
                        </TableRow>}
                        {detail.hasMap && <TableRow>
                            <TableCell>
                                动态地图功能
                            </TableCell>
                            <TableCell>
                                {priceObj.hasMap}
                            </TableCell>
                        </TableRow>}
                        {detail.hasImages && <TableRow>
                            <TableCell>
                                相册功能
                            </TableCell>
                            <TableCell>
                                {priceObj.hasImages}
                            </TableCell>
                        </TableRow>}
                        {detail.hasVideos && <TableRow>
                            <TableCell>
                                视频播放功能
                            </TableCell>
                            <TableCell>
                                {priceObj.hasVideos}
                            </TableCell>
                        </TableRow>}
                        {detail.hasFiles && <TableRow>
                            <TableCell>
                                文档下载功能
                            </TableCell>
                            <TableCell>
                                {priceObj.hasFiles}
                            </TableCell>
                        </TableRow>}
                        {detail.hasBeiancode && <TableRow>
                            <TableCell>
                                备案码(可选)
                            </TableCell>
                            <TableCell>
                                {priceObj.hasBeiancode}
                            </TableCell>
                        </TableRow>}
                        {detail.hasDomain && <TableRow>
                            <TableCell>
                                CN域名/年(可选)
                            </TableCell>
                            <TableCell>
                                {priceObj.hasDomain}
                            </TableCell>
                        </TableRow>}
                        {detail.hasSpace && <TableRow>
                            <TableCell>
                                云空间/年(可选)
                            </TableCell>
                            <TableCell>
                                {priceObj.hasSpace}
                            </TableCell>
                        </TableRow>}
                        {detail.hasCdn && <TableRow>
                            <TableCell>
                                网站加速CDN流量包100G/年(可选)
                            </TableCell>
                            <TableCell>
                                {priceObj.hasCdn}
                            </TableCell>
                        </TableRow>}
                        <TableRow>
                            <TableCell>
                                总计
                            </TableCell>
                            <TableCell>
                                {totalPrice}
                            </TableCell>
                        </TableRow>
                    </TableBody>
                    <TableFooter className={classes.baojiadanFooter}>
                        <TableRow>
                            仿站注意事项：<br />
                            1、仿站属于定制开发，源码交付后不支持退款；<br />
                            2、仿站工期一般7个工作日交付对接细节修改；<br />
                            3、仿站框架和效果一模一样，不能做的细节处会事前确认沟通好；<br />
                            4、仿站开始前要确定好修改的地方和内容，后期增加的需求需要另外评估费用，定稿后可以免费修改5处细节。
                        </TableRow>
                    </TableFooter>
                </Table>
            </DialogContent>
        </Dialog>)
    }
}

class DeleteDialog extends Component {
    render() {
        const {dispatch,showModal} = this.props
        return (<Dialog
            open={showModal.delete}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
        >
            <DialogContent>确定删除吗？</DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                <Button variant="outlined" color="primary" onClick={() => dispatch(actions.remove(showModal.id))}>确定</Button>
            </DialogActions>
        </Dialog>)
    }
}

const AddFormDialog = connect(
    state => {
        return {
            initialValues: {
                menuCount: "1",
                languageCount: 1,
                hasMobile: false,
                hasForm: false,
                hasNews: false,
                hasProduct: false,
                hasFocus: false,
                hasMap: false,
                hasImages: false,
                hasVideos: false,
                hasFiles: false,
                hasDomain: true,
                hasSpace: true,
                hasBeiancode: false,
                hasCdn: false,
                ...state.baojiadan.showModal.extra
            }
        }
    },
)(reduxForm({
    form: 'baojiadanAddForm',
    validate
})(AddDialog))

const UpdateFormDialog = connect(
    state => {
        const selector = formValueSelector('baojiadanUpdateForm')
        return {
            initialValues: {
                ...state.baojiadan.detail, 
                orderTime: dateFormat(new Date(state.baojiadan.detail.orderTime), 'yyyy-MM-dd'), 
                sendEmailTime: dateFormat(new Date(state.baojiadan.detail.sendEmailTime), 'yyyy-MM-ddTHH:mm')
            },
            permissionMap: state.auth.user.permissionMap,
            isNeedBuyDomain: selector(state, 'isNeedBuyDomain'),
            isNeedDecoration: selector(state, 'isNeedDecoration')
        }
    },
  )(reduxForm({
    form: 'baojiadanUpdateForm',
    validate
})(UpdateDialog))


class Baojiadan extends Component {
    componentDidMount() {
        const {dispatch}  = this.props
        dispatch(actions.getList())
    }
    onPageClick = (index) => {
        const {dispatch,page} = this.props
        dispatch({
            type: actions.CHANGE_PAGE,
            page: {...page, index}
        })
        dispatch(actions.getList())
    }
    handleFiltersClick = (value) => {
        const { dispatch,filterList } = this.props
        const valueItem = filterList.find(item=>item.value === value);
        valueItem.isShow = !valueItem.isShow;
        dispatch({type: actions.CHANGE_FILTER_LIST,value: _.clone(filterList)})
    }
    cancelFiltersClick = (value) => {
        const { dispatch, query } = this.props
        this.handleFiltersClick(value);
        if (query[value]) {
            dispatch({type: actions.CHANGE_QUERY, key: value, value: null})
            dispatch(actions.getList())
        }
    }
    changeQuery = (e,name) => {
        const {dispatch} = this.props;
        dispatch({type: actions.CHANGE_QUERY,key: name,value: e.target ? e.target.value : e})
        dispatch(actions.getList())
    }
    render() {
        const {classes, dispatch, list, page, total ,permissionMap, showModal} = this.props
        return (
            <div>
                <Grid container spacing={8} alignItems="baseline">
                    <Grid item>
                        {permissionMap['报价单_新增'] && <Button variant="outlined" color="secondary" onClick={() => dispatch({type: actions.SHOW_MODAL, key: 'add', extra: {category: '单页'}})}>单页</Button>}
                    </Grid>
                    <Grid item>
                        {permissionMap['报价单_新增'] && <Button variant="outlined" color="secondary" onClick={() => dispatch({type: actions.SHOW_MODAL, key: 'add', extra: {category: '单页带表单', hasForm: true}})}>单页带表单</Button>}
                    </Grid>
                    <Grid item>
                        {permissionMap['报价单_新增'] && <Button variant="outlined" color="secondary" onClick={() => dispatch({type: actions.SHOW_MODAL, key: 'add', extra: {category: '公司官网H5', menuCount: '5-10', hasForm: true, hasNews: true, hasProduct: true, hasFocus: true, hasMap: true}})}>公司官网H5</Button>}
                    </Grid>
                    <Grid item>
                        {permissionMap['报价单_新增'] && <Button variant="outlined" color="secondary" onClick={() => dispatch({type: actions.SHOW_MODAL, key: 'add', extra: {category: '公司官网3合1', menuCount: '5-10', hasMobile: true, hasForm: true, hasNews: true, hasProduct: true, hasFocus: true, hasMap: true}})}>公司官网3合1</Button>}
                    </Grid>
                    <Grid item>
                        {permissionMap['报价单_新增'] && <Button variant="outlined" color="secondary" onClick={() => dispatch({type: actions.SHOW_MODAL, key: 'add', extra: {category: '营销推广', menuCount: '1-5', hasForm: true, hasFocus: true, hasMap: true}})}>营销推广</Button>}
                    </Grid>
                </Grid>
                {/* <Grid container spacing={8}>
                    {filterList.filter(item => item.isShow).map((item, index) => {
                        return (
                            <EnhancedFilterField
                                item={item}
                                value={query[item.value]}
                                key={index}
                                onHandleQuery={(e) => this.changeQuery(e, item.value)}
                                hideCancelBtn={item.hideCancelBtn}
                                onCancel={this.cancelFiltersClick}
                            />
                        );
                    })}
                </Grid> */}
                <Paper className={classes.root}>
                    {list.length === 0 && <NoData />}
                    {list.length > 0 && <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell className={classes.tableCell}>客户信息</TableCell>
                                <TableCell className={classes.tableCell}>基础信息</TableCell>
                                <TableCell className={classes.tableCell}>功能信息</TableCell>
                                <TableCell className={classes.tableCell}>参考价格</TableCell>
                                <TableCell>操作</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {list.map(row => {
                                const price = getBaojia(row);
                                const copyContent = `
如同意须知和报价填写下面信息发给我。
手机号：
邮箱：
域名： 
仿站链接: ${row.link}
仿站技术报价: ${price}
需知：
1、仿站做好后，网站源码所有权属于您，您可以随时联系客服，索要网站源码。
2、网站后台为我们公司自主开发的云后台，为安全性考虑，后台不提供源码，只提供个人网站管理，用户可以随时登录更改网站和发布内容等。
3、您无需会编程，就可以方便的使用后台更新文章、产品、seo信息，也可以通过可视化界面，修改网站大部分的文字和图片。
4、网站做好后，和原网站框架一致，原网站的新闻、产品，我们只上传部分，其他需您在后台上传修改，或者联系我们额外付费代发布。
5、仿站开始后，请尽快提交修改文档，方便技术尽快完成网站初稿。约定初稿交付时限从提供完整信息后开始计算。
                                `   
                                return (
                                    <TableRow key={row.id}>
                                        <TableCell className={classes.tableCell}>
                                            <p>旺旺号: {row.aliwangwang}</p>
                                            <p>仿站类型: {row.category}</p>
                                            <p>仿站链接: <a href={`${row.link.indexOf('http') !== -1 ? row.link : `http://${row.link}`}`} target="_blank">查看</a></p>
                                            <p>创建人: {row.accountName}</p>
                                            <p>创建日期: {dateFormat(new Date(row.createTime))}</p>
                                        </TableCell>
                                        <TableCell className={classes.tableCell}>
                                            <p>栏目数量: {row.menuCount}</p>
                                            <p>语言数量: {row.languageCount}</p>
                                            <p>
                                                <FormControlLabel
                                                control={
                                                    <Switch
                                                    checked={row.hasMobile}
                                                    onChange={()=>dispatch(actions.update({...row, hasMobile: !row.hasMobile}))}
                                                    value={row.hasMobile}
                                                    />
                                                }
                                                label="独立手机端"
                                                />
                                            </p>
                                        </TableCell>
                                        <TableCell className={classes.tableCell}>
                                            <p>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                        checked={row.hasForm}
                                                        onChange={()=>dispatch(actions.update({...row, hasForm: !row.hasForm}))}
                                                        value={row.hasForm}
                                                        />
                                                    }
                                                    label="是否有表单模块"
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                        checked={row.hasNews}
                                                        onChange={()=>dispatch(actions.update({...row, hasNews: !row.hasNews}))}
                                                        value={row.hasNews}
                                                        />
                                                    }
                                                    label="是否有新闻模块"
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                        checked={row.hasProduct}
                                                        onChange={()=>dispatch(actions.update({...row, hasProduct: !row.hasProduct}))}
                                                        value={row.hasProduct}
                                                        />
                                                    }
                                                    label="是否有产品模块"
                                                />
                                            </p>
                                            <p>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                        checked={row.hasFocus}
                                                        onChange={()=>dispatch(actions.update({...row, hasFocus: !row.hasFocus}))}
                                                        value={row.hasFocus}
                                                        />
                                                    }
                                                    label="是否有焦点图"
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                        checked={row.hasMap}
                                                        onChange={()=>dispatch(actions.update({...row, hasMap: !row.hasMap}))}
                                                        value={row.hasMap}
                                                        />
                                                    }
                                                    label="是否有地图模块"
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                        checked={row.hasImages}
                                                        onChange={()=>dispatch(actions.update({...row, hasImages: !row.hasImages}))}
                                                        value={row.hasImages}
                                                        />
                                                    }
                                                    label="是否有图片集模块"
                                                />
                                            </p>
                                            <p>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                        checked={row.hasVideos}
                                                        onChange={()=>dispatch(actions.update({...row, hasVideos: !row.hasVideos}))}
                                                        value={row.hasVideos}
                                                        />
                                                    }
                                                    label="是否有视频播放模块"
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                        checked={row.hasFiles}
                                                        onChange={()=>dispatch(actions.update({...row, hasFiles: !row.hasFiles}))}
                                                        value={row.hasFiles}
                                                        />
                                                    }
                                                    label="是否有文档下载模块"
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                        checked={row.hasBeiancode}
                                                        onChange={()=>dispatch(actions.update({...row, hasBeiancode: !row.hasBeiancode}))}
                                                        value={row.hasBeiancode}
                                                        />
                                                    }
                                                    label="是否需要备案码"
                                                />
                                            </p>
                                            <p>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                        checked={row.hasDomain}
                                                        onChange={()=>dispatch(actions.update({...row, hasDomain: !row.hasDomain}))}
                                                        value={row.hasDomain}
                                                        />
                                                    }
                                                    label="是否有域名"
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                        checked={row.hasSpace}
                                                        onChange={()=>dispatch(actions.update({...row, hasSpace: !row.hasSpace}))}
                                                        value={row.hasSpace}
                                                        />
                                                    }
                                                    label="是否需要云空间"
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                        checked={row.hasCdn}
                                                        onChange={()=>dispatch(actions.update({...row, hasCdn: !row.hasCdn}))}
                                                        value={row.hasCdn}
                                                        />
                                                    }
                                                    label="是否需要CDN加速"
                                                />
                                            </p>
                                        </TableCell>
                                        <TableCell>
                                            {price - 100} ~ {price}
                                        </TableCell>
                                        <TableCell className={classes.tableCell}>
                                            {permissionMap['报价单_查询'] && <a href={`javascript:;`} onClick={()=>dispatch(actions.showUpdateModal(row.id, true))}>查看详情</a>}<br/><br/>
                                            {permissionMap['报价单_修改'] && <a href={`javascript:;`} onClick={()=>dispatch(actions.showUpdateModal(row.id, false))}>修改</a>}<br/><br/>
                                            {permissionMap['报价单_删除'] && <a href={`javascript:;`} onClick={()=>dispatch({type: actions.SHOW_MODAL,key: 'delete', id: row.id})}>删除</a>}<br/><br/>
                                            {permissionMap['报价单_修改'] && <a href={`javascript:;`} onClick={()=>dispatch(actions.showBaojiadanModal(row.id, false))}>生成报价单</a>}<br/><br/>
                                            {permissionMap['报价单_修改'] && <CopyToClipboard text={copyContent}  onCopy={() => dispatch(tip.success('复制成功'))}>
                                                    <a href={`javascript:;`}>复制报价</a>
                                                </CopyToClipboard>}
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                        <TableFooter>
                            <Pagination 
                                total={total}
                                {...page}
                                onPageClick={this.onPageClick}
                            />
                        </TableFooter>
                    </Table>}
                </Paper>
                {showModal.add && <AddFormDialog {...this.props} onSubmit={(formData)=>dispatch(actions.add(formData))}/>}
                {showModal.update && <UpdateFormDialog {...this.props} onSubmit={(formData)=>dispatch(actions.update(formData))} />}
                {showModal.baojiadan && <BaojiadanDialog {...this.props} />}
                {showModal.delete && <DeleteDialog {...this.props} />}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state.baojiadan,
        permissionMap: state.auth.user.permissionMap
    }
}

export default connect(mapStateToProps)(withStyles(styles)(Baojiadan))



// WEBPACK FOOTER //
// ./src/pages/home/routes/baojiadan/components/list.js